import styled from 'styled-components';
import { ifProp, prop } from 'styled-tools';
import { layout, media } from '@prisjakt/ui-base';
import Magnify from 'mdi-react/MagnifyIcon';

import { height } from '../styles';

const ITEM_HEIGHT = '40px';

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${layout.pageContent.maxWidth.rem};
  margin: 0 auto;
`;

export const Inner = styled.div`
  position: absolute;
  max-width: ${layout.pageContent.maxWidth.rem};
  width: 100%;
  ${media.smallOnly`
      scroll-behavior: smooth;
      overflow: auto;
      position: fixed;
      top: ${height.mobileWithSearch};
      bottom: 0;
      background: white;
    `}
`;

export const Suggestions = styled.ul`
  width: 49%;
  margin: 0 auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background: white;
  min-height: 100px;
  padding: 5px 0px;
  border: 1px solid ${p => p.theme.colors.base200};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  list-style: none;

  ${media.smallOnly`
    border: none;
    overflow: hidden;
    border-radius: none;
    width: 100%;
  `}
`;

type ItemProps = { selected?: boolean; disabled?: boolean };
export const Item = styled.li<ItemProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${ITEM_HEIGHT};
  padding-left: 20px;
  padding-right: 10px;
  background: ${ifProp('selected', 'rgba(72,149,182,0.1)', 'transparent')};
  :hover {
    background: ${p => p.theme.colors.base200};
  }
  opacity: ${ifProp('disabled', 0.3, 1)};
  ${media.smallOnly`
    border-bottom: 1px solid ${p => p.theme.colors.base200};
  `}
`;

export const AdItem = styled.li``;

type OriginalQueryProps = { selected?: boolean };
export const OriginalQuery = styled.div<OriginalQueryProps>`
  padding: 0;
  margin-bottom: 5px;
  font-size: 16px;
  border-bottom: 1px solid
    ${ifProp('selected', 'transparent', prop('theme.colors.base200'))};
  ${media.smallOnly`
    border-bottom: none;
  `}
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const ExtendSearch = styled.span``;

export const DirectLink = styled.span`
  color: ${p => p.theme.colors.base400};
  font-size: 12px;
  padding-left: 15px;
`;

type IconProps = { storeLogo?: boolean };
export const Icon = styled.img<IconProps>`
  width: ${ifProp('storeLogo', '50px', '25px')};
  height: ${ifProp('storeLogo', 'auto', '25px')};
`;

export const SearchIcon = styled(Magnify)`
  path {
    fill: ${p => p.theme.colors.base300};
  }
`;

export const IconWrapper = styled.span`
  width: 30px;
  height: ${ITEM_HEIGHT};
  margin-right: 10px;
  display: flex;
  align-items: center;
`;

export const RowInfo = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
`;
